<template>
    <transition name="fade-table">
        <nav
            v-show="scrolled < 150"
            class="py-3 navbar navbar-expand-lg fixed-top auto-hiding-navbar navbar-light animated_dropdown"
            :class="{ 'navbar-light-scrolled': scrolled > 3 }"
        >
            <div class="container">
                <a class="navbar-brand py-0" href="/" target="_blank"><span></span></a>
                <button class="navbar-toggler" type="button" v-on:click="collapsed = !collapsed">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <transition name="slide">
                    <div class="navbar-collapse" v-show="!collapsed">
                        <ul class="navbar-nav ml-auto">
                            <li class="nav-item mx-1" v-for="item in menuItems" :key="`menu-item-${item.name}`">
                                <router-link :to="item.path" v-html="item.name" class="nav-link" />
                            </li>

                            <li
                                class="nav-item mx-1 dropdown"
                                :class="{ show: profileOpen }"
                                v-click-outside="() => (profileOpen = false)"
                            >
                                <a
                                    href="#"
                                    class="nav-link dropdown-toggle"
                                    role="button"
                                    v-on:click="profileOpen = !profileOpen"
                                >
                                    <i class="fa fa-user mr-2"></i>
                                    Profile
                                </a>
                                <div class="dropdown-menu animated_dropdown shadow-lg" :class="{ show: profileOpen }">
                                    <router-link class="dropdown-item" to="/profile">Edit profile</router-link>

                                    <router-link class="dropdown-item" to="/clients/edit">
                                        Edit current client
                                    </router-link>

                                    <button class="dropdown-item" v-on:click="logout">Logout</button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </transition>
            </div>
        </nav>
    </transition>
</template>

<script>
    import Vue from 'vue';

    import ClickOutside from 'vue-click-outside';

    import authService from '@api/auth';

    export default Vue.extend({
        directives: {
            ClickOutside
        },
        data() {
            const menuItems = [
                { name: 'Enquiries', path: '/enquiries' },
                { name: 'Patients', path: '/patients' },
                { name: 'Invoices', path: '/invoices' },
                { name: 'Sessions', path: '/sessions' },
                { name: 'Reports', path: '/reports' }
            ];

            if (authService.can_manage) {
                menuItems.push({ name: 'Users', path: '/users' });
            }

            return {
                collapsed: true,
                profileOpen: false,
                scrolled: 0,
                menuItems: menuItems
            };
        },
        watch: {
            '$route.path'() {
                this.collapsed = true;
                this.profileOpen = false;
            }
        },
        methods: {
            logout() {
                authService
                    .logout()
                    .then(() => {
                        window.location.reload();
                    })
                    .catch(() => {
                        this.$toasted.error('We could not proceed. Please try again.', {
                            icon: 'exclamation-triangle'
                        });
                    });
            }
        },
        mounted() {
            window.addEventListener('scroll', (event) => {
                this.scrolled = window.scrollY;
            });
        }
    });
</script>
